import { useEffect, useRef } from 'react'

export default function usePageLoad(callback: () => void, delay = 0) {
  const loaded = useRef(false)

  useEffect(() => {
    if (loaded.current) return
    loaded.current = true
    setTimeout(callback, delay)
  }, [delay, callback])
}
